import { render, staticRenderFns } from "./GFReasonsForSeparation.vue?vue&type=template&id=837be512"
import script from "./GFReasonsForSeparation.vue?vue&type=script&lang=js"
export * from "./GFReasonsForSeparation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports